import React, { useState, useEffect } from "react";
import "./App.css";
import { toast } from "react-toastify";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Home from "./Components/Home/Home";
import SignupForm from "./Components/SignupForm/SignupForm";
import LoginForm from "./Components/LoginForm/LoginForm";
import ForgotPassword from "./Components/ForgotPassword/ForgotPassword";
import { getAccountDetails } from "./Components/Services/localStorage";
import Inspection from "./Components/Inspection/Inspection";
import Templates from "./Components/Templates/Templates";
import CreateTemplate from "./Components/CreateTemplate/CreateTemplate";
import UpdateTemplate from "./Components/UpdateTemplate/UpdateTemplate";
import InspectionScreen from "./Components/InspectionScreen/InspectionScreen";
import CMVTable from "./Components/CMVTable/CMVTable";
import DocGenerateTest from "./Components/ExportWordDoc/DocGenerateTest";
import CsaAudit from "./Components/Csa/CsaAudit";
import CsaNewAudit from "./Components/Csa/CsaNewAudit";
import CsaAuditList from "./Components/Csa/CsaAuditList";
import ElectricalAuditList from "./Components/Electrical/ElectricalAuditList";
import ElectricalNewAudit from "./Components/Electrical/ElectricalNewAudit";
import ElectricalAudit from "./Components/Electrical/ElectricalAudit";

function App() {
  const [loginSuccess, setLoginSuccess] = useState(false);
  const { accessToken, userId } = getAccountDetails();

  // Jodit boxes shouldn't accept pasted images - block at the document level
  // (capture phase, before Jodit's own paste handler on the editor node)
  // so it applies to every Jodit instance across the app in one place.
  useEffect(() => {
    const blockImagePasteInJodit = (e) => {
      const target = e.target;
      if (!target || typeof target.closest !== "function") return;
      if (!target.closest(".jodit-wysiwyg")) return;

      const clipboardData = e.clipboardData || window.clipboardData;
      if (!clipboardData) return;

      const hasImage =
        Array.from(clipboardData.files || []).some((f) => f.type.startsWith("image/")) ||
        Array.from(clipboardData.items || []).some((item) => item.kind === "file" && item.type.startsWith("image/"));

      if (hasImage) {
        e.preventDefault();
        e.stopPropagation();
        toast.warning("Images cannot be pasted here.");
      }
    };

    document.addEventListener("paste", blockImagePasteInJodit, true);
    return () => document.removeEventListener("paste", blockImagePasteInJodit, true);
  }, []);

  return (
    <div className="App">
      <Router>
        <Routes>
          {/* Redirect to home if accessToken is present */}
          <Route path="/" element={accessToken ? <Navigate to="/home" /> : <LoginForm setLoginSuccess={setLoginSuccess} />} />
          <Route path="/signup" element={accessToken ? <Navigate to="/home" /> : <SignupForm />} />
          <Route path="/home" element={<Home loginSuccess={loginSuccess} />} />
          <Route path="/forgot-password" element={accessToken ? <Navigate to="/home" /> : <ForgotPassword />} />
          <Route path="/inspection" element={<Inspection />} />
          <Route path="/templates" element={<Templates />} />
          <Route path="/create-template" element={<CreateTemplate />} />
          <Route path="/update-template/:templateId" element={<UpdateTemplate />} />
          <Route path="/start-inspection/:templateId" element={<InspectionScreen />} />
          <Route path="/cmv/:report_id" element={<CMVTable />} />
          {/* CSA — a full-screen route, not a panel: the capture screen is used
              standing up on a tablet and needs the whole viewport. */}
          <Route path="/csa-audits" element={<CsaAuditList />} />
          <Route path="/csa-new" element={<CsaNewAudit />} />
          <Route path="/csa-audit/:auditId" element={<CsaAudit />} />
          {/* Electrical — same reasoning as CSA above: a full-screen route,
              not a panel, for standalone navigation. */}
          <Route path="/electrical-audits" element={<ElectricalAuditList />} />
          <Route path="/electrical-new" element={<ElectricalNewAudit />} />
          <Route path="/electrical-audit/:auditId" element={<ElectricalAudit />} />
          {/* <Route path="/docGenerateTest" element={<DocGenerateTest/>} /> */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;

